import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3" }

import { InputRow, Combobox } from '@/components/ui/form';
    import { useEconomicProjectData } from '@/composables/useEconomicProjectData';
    import { watch } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherAssignProjectForm',
  props: {
    form: {},
    companyId: {}
  },
  setup(__props: any) {

    const props = __props;

    const { projects, isPlaceholderDataProjects } = useEconomicProjectData(props.companyId);

    watch(
        () => projects.value,
        (newProjects) => {
            props.form.projects = newProjects;
        },
        { immediate: true },
    );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "project_id",
      label: "vouchers.select.project_confirm.project"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Combobox), {
          modelValue: _ctx.form.project_id,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.project_id) = $event)),
          options: _unref(projects),
          "label-by": "name",
          "value-by": "number",
          loading: _unref(isPlaceholderDataProjects)
        }, null, 8, ["modelValue", "options", "loading"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})